import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export async function getListUser(): Promise<any> {
    return await API.get(API_NAME, `user/user`, {});
}

export async function addUser(postData: any): Promise<any> {
    return await API.post(API_NAME, `user/add`, { body: postData });
}

export async function editUser(postData: any): Promise<any> {
    return await API.put(API_NAME, `user/edit`, { body: postData });
}

export async function listUser(postData: any): Promise<any> {
    return await API.get(API_NAME, `user/list?page=${postData.page}&limit=${postData.limit}&sortField=${postData.sortField}&filters=${encodeURIComponent(JSON.stringify(postData.filters))}&sortOrder=${postData.sortOrder}`, {});
}

export async function getUserDetailsById(id: number): Promise<any> {
    return await API.get(API_NAME, `user/get?id=${id}`, {});
}

export async function getUserDetailsByEmail(userEmail: any): Promise<any> {
    return await API.get(API_NAME, `user/get?email=${userEmail}`, {});
}

export async function enableOrDisableUser(postData: any): Promise<any> {
    return await API.post(API_NAME, 'user/status', { body: postData });
}

export async function updateCognitoPassword(postData: any): Promise<any> {
    return await API.post(API_NAME, `user/update-password`, { body: postData });
}